import { fromJS, Record } from 'immutable';
import { createDuck } from 'redux-duck';
import { SubmissionError } from 'redux-form';

// middleware
import { api, formatError } from '../middleware/client';

const BASE_URL = `${process.env.REACT_APP_REST_URI}/home`;

const duck = createDuck('Home', 'nabor');
const LOAD_TYPE = duck.defineType('LOAD');
const LOAD_SUCCESS_TYPE = duck.defineType('LOAD_SUCCESS');
const LOAD_FAIL_TYPE = duck.defineType('LOAD_FAIL');
const LOAD_NEWS_TYPE = duck.defineType('LOAD_NEWS');
const LOAD_NEWS_SUCCESS_TYPE = duck.defineType('LOAD_NEWS_SUCCESS');
const LOAD_NEWS_FAIL_TYPE = duck.defineType('LOAD_NEWS_FAIL');

const StatsRecord = Record({
  numNewListings: null,
  numForSale: null,
  numOpenHouses: null,
  numCommercial: null,
  temp: null,
  weather: ''
});

const initialState = fromJS({
  loaded: false,
  loading: false,
  error: undefined,
  stats: new StatsRecord(),
  contactUsSaving: false,
  contactUsSaved: false,
  contactUsError: undefined,
  news: {
    loaded: false,
    loading: false,
    results: []
  }
});

function reducer(state = initialState, action) {
  switch (action.type) {
    case LOAD_TYPE:
      state = state.merge({
        loading: true,
        error: undefined
      });
      break;
    case LOAD_SUCCESS_TYPE:
      state = state.merge({
        loaded: true,
        loading: false,
        error: undefined,
        stats: new StatsRecord(action.payload)
      });
      break;
    case LOAD_FAIL_TYPE:
      state = state.merge({
        loaded: false,
        loading: false,
        error: formatError(action.payload)
      });
      break;
    case LOAD_NEWS_TYPE:
      state = state.mergeIn(['news'], {
        loading: true,
        error: undefined
      });
      break;
    case LOAD_NEWS_SUCCESS_TYPE:
      state = state.mergeIn(['news'], {
        loaded: true,
        loading: false,
        error: undefined,
        results: action.payload.list
      });
      break;
    case LOAD_NEWS_FAIL_TYPE:
      state = state.mergeIn(['news'], {
        loaded: false,
        loading: false,
        error: formatError(action.payload)
      });
      break;
    default:
      break;
  }

  return state;
}

function LOAD(params) {
  return {
    types: [LOAD_TYPE, LOAD_SUCCESS_TYPE, LOAD_FAIL_TYPE],
    promise: client => client.get(BASE_URL)
  };
}

function CONTACT_SUBMIT(values) {
  return api
    .post(`${process.env.REACT_APP_REST_URI}/contact`, {
      data: values
    })
    .catch(function (error) {
      throw new SubmissionError({
        _error: formatError(error)
      });
    });
}

function LOAD_NEWS(params) {
  return {
    types: [LOAD_NEWS_TYPE, LOAD_NEWS_SUCCESS_TYPE, LOAD_NEWS_FAIL_TYPE],
    promise: client => client.get(`${process.env.REACT_APP_REST_URI}/get-market-stats`)
  };
}

export { StatsRecord, LOAD, CONTACT_SUBMIT, LOAD_NEWS };
export default reducer;



// WEBPACK FOOTER //
// ./src/ducks/Home.js